import { useBeforeUnload } from '../hooks/useBeforeUnload'

export type LeavingGuardProps = {
  when: boolean
}

export const LeavingGuard = ({ when }: LeavingGuardProps) => {
  useBeforeUnload(when)

  return null
}
